import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function House(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M18.284 4.09l.07.058 13.498 13.498a.5.5 0 01-.638.765l-.069-.057-2.646-2.646.001 14.8c0 .78-.595 1.421-1.356 1.494l-.144.007H9a1.5 1.5 0 01-1.493-1.356L7.5 30.51V15.712l-2.642 2.642a.501.501 0 01-.638.057l-.07-.057a.501.501 0 01-.057-.638l.058-.07L17.646 4.148a.501.501 0 01.638-.057zM24 31.009h3a.5.5 0 00.492-.41l.008-.09v-15.8l-9.5-9.5-9.5 9.502v15.798a.5.5 0 00.41.492l.09.008h9V21a1 1 0 011-1h4a1 1 0 011 1v10.008zM23 21h-4v10h4V21zm-9-1a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2zm0 1h-2v2h2v-2z"></path>
    </IconSvg>
  );
}
